import * as angular from 'angular';
import {PricePlanBundleRequestsService} from "./price-plan-bundle-requests.service";
import {ItemSetting} from "../models/itemSetting.model";
import {PricePlanAlertsService} from "./price-plan-alerts.service";
import {IQService} from "angular";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {ServiceValidationTemplateModel} from "../models/service-validation-template.model";
import * as _ from "lodash";
import {ExportType} from "../../commons/types/export.type";
import {ExportPricePlanPayloadModel} from "../angular/models/export-price-plan-payload.model";

export class PricePlanBundleService {

  constructor(private pricePlanBundleRequestsService: PricePlanBundleRequestsService,
              private pricePlanAlertsService: PricePlanAlertsService,
              private bringozLoaderService: BringozLoaderService, private $log, private $q: IQService) {
  }

  getPackageItems() {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.pricePlanBundleRequestsService.getPackageItems()
      .then((res: ItemSetting[]) => {
        deferred.resolve(res);
      })
      .catch((error) => {
        this.pricePlanAlertsService.getPackageItemsError();
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise;
  }

  createPackageItem(packageItem: ItemSetting) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.pricePlanBundleRequestsService.createPackageItem(packageItem)
      .then((res) => {
        this.pricePlanAlertsService.createPackageItemSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.pricePlanAlertsService.createPackageItemError();
        this.$log.error(error);
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise;
  }

  updatePackageItem(itemId, packageItem: ItemSetting) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.pricePlanBundleRequestsService.updatePackageItem(itemId, packageItem)
      .then((res) => {
        this.pricePlanAlertsService.updatePackageItemSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.pricePlanAlertsService.updatePackageItemError();
        this.$log.error(error);
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise;
  }

  setDefaultPackageItem(itemId) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.pricePlanBundleRequestsService.setDefaultPackageItem(itemId)
      .then((res) => {
        this.pricePlanAlertsService.updateDefaultPackageItemSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.pricePlanAlertsService.updateDefaultPackageItemError();
        this.$log.error(error);
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise;
  }

  updatePricePlanBundle(pricePlanBundle, accountId) {
    const deferred = this.$q.defer();
    this.bringozLoaderService.on();

    this.pricePlanBundleRequestsService.editBundle(pricePlanBundle.id, pricePlanBundle, accountId)
      .then((updatedPricePlanBundle) => {
        deferred.resolve(updatedPricePlanBundle);
        this.pricePlanAlertsService.updateSuccess();
      })
      .catch((error) => {
        deferred.reject(error);
        this.pricePlanAlertsService.updateError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise;
  }

  exportPrograms(pricePlanBundleId: string, payload: ExportPricePlanPayloadModel) {
    const deferred = this.$q.defer();
    this.bringozLoaderService.on();

    this.pricePlanBundleRequestsService.exportPrograms(pricePlanBundleId, payload)
      .then((res) => {
        deferred.resolve(res);
        this.pricePlanAlertsService.exportSuccess();
      })
      .catch((error) => {
        deferred.reject(error);
        this.pricePlanAlertsService.exportError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise;
  }

  getHierarchy() {

    const deferred = this.$q.defer();
    this.bringozLoaderService.on();

    this.pricePlanBundleRequestsService.getHierarchy()
      .then((hierarchy) => {
        deferred.resolve(hierarchy);
      })
      .catch((error) => {
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise;
  }

  updatePricePlanAccounts(pricePlanBundleId: string, accountIds: string[]) {
    const deferred = this.$q.defer();
    this.bringozLoaderService.on();

    this.pricePlanBundleRequestsService.updatePricePlanBundleAccounts(pricePlanBundleId, accountIds)
      .then((updatedPricePlanBundle) => {
        deferred.resolve(updatedPricePlanBundle);
        this.pricePlanAlertsService.updateSuccess();
      })
      .catch((error) => {
        deferred.reject(error);
        this.pricePlanAlertsService.updateError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise;
  }

  updateLineSplitConfiguration(lineSplitConfiguration) {
    const deferred = this.$q.defer();
    this.bringozLoaderService.on();

    this.pricePlanBundleRequestsService.updateLineSplitConfiguration(lineSplitConfiguration)
      .then((res) => {
        deferred.resolve(res);
        this.pricePlanAlertsService.updateLineSplitConfigurationSuccess();
      })
      .catch((error) => {
        deferred.reject(error);
        this.pricePlanAlertsService.updateLineSplitConfigurationError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise;
  }

  getServiceValidations() {
    const deferred = this.$q.defer();
    this.bringozLoaderService.on();

    this.pricePlanBundleRequestsService.getServiceValidations()
      .then((res) => {
        deferred.resolve(res);
      })
      .catch((error) => {
        deferred.reject(error);
        this.pricePlanAlertsService.getServiceValidationsError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise;
  }

  createServiceValidations(serviceValidation: ServiceValidationTemplateModel) {
    const deferred = this.$q.defer();
    this.bringozLoaderService.on();

    this.pricePlanBundleRequestsService.createServiceValidations(serviceValidation)
      .then((res) => {
        this.pricePlanAlertsService.createServiceValidationSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        deferred.reject(error);
        this.pricePlanAlertsService.createServiceValidationError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise;
  }

  updateServiceValidations(serviceValidation: ServiceValidationTemplateModel, isArchive?: boolean) {
    const deferred = this.$q.defer();
    this.bringozLoaderService.on();

    this.pricePlanBundleRequestsService.updateServiceValidations(serviceValidation)
      .then((res) => {
        if (isArchive) {
          this.pricePlanAlertsService.deleteServiceValidationSuccess();
        } else {
          this.pricePlanAlertsService.updateServiceValidationSuccess();
        }
        deferred.resolve(res);
      })
      .catch((error) => {
        if (isArchive) {
          this.pricePlanAlertsService.deleteServiceValidationError();
        } else {
          this.pricePlanAlertsService.updateServiceValidationError();
        }
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise;
  }

  getServiceValidationsGroupsByIds(ids) {
    return _.map(ids, (id) => {
      return {
        type: "ServiceValidation",
        group: "ServiceValidation",
        value: {
          id: id,
          isEnabled: true,
          isDefault: false
        },
        id: id
      }
    });
  }

}

angular
  .module('bringoz.admin.pricePlan')
  .service('pricePlanBundleService', PricePlanBundleService);
